export const ZONE_IDS = {
	SMALL_CARD: '679331',
	LONG_CARD: '679332',
	BANNER: '679340',
	TOURNEY_CARD: '688399',
	LEAGUE_CARD: '688401',
	MODAL: '721101',
	TOURNEY_SEARCH: '788107',
	MODAL_REDESIGNED: '809175',
	VIDEO: '940896',
	VIDEO_2: '949638',
	NEW_BANNER: '946048'
};
